import { createContext } from "react";

export interface PrivyLoginBootstrap {
  customLoginRequested: boolean;
  requestCustomLogin: () => void;
  clearCustomLogin: () => void;
}

// User intent lives above the guest/Privy provider switch so the custom login
// dialog can open after the SDK is available without invoking Privy's own UI.
export const PrivyLoginBootstrapContext =
  createContext<PrivyLoginBootstrap | null>(null);
